module.exports = __webpack_public_path__ + "static/banner-070bb8d80b866bb7c9ea5aeef017a07b.png";